import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";
import { TableColumnWithIcon } from "../../../pages/DashboardPage/acadia/mock";
import { FlexCol, FlexRow } from "../../../utils/flexLayouts";

export type TableHeaderColumnProps = {
  tableHeaderContent: TableColumnWithIcon;
  sortDirection: "asc" | "desc" | "default";
  onClick?: () => void;
  onStatusClickIcon?: () => void;
  sortStatus?: number;
};

function Table({
  header,
  body,
  page,
  limit,
  count,
  numberOfPages,
  onChangePage,
  tableName,
}: {
  header: any;
  body: any[];
  limit: number;
  count: number;
  page: number;
  numberOfPages: number;
  onChangePage: (page: number) => void;
  tableName: string;
}) {
  // const [sortedField, setSortedField] = useState<TableHeaderFields | null>(null);
  // const [sortDirection, setSortDirection] = useState<"asc" | "desc" | "default">("default");

  // const handleSort = (field: TableHeaderFields) => {
  //   if (sortedField === field) {
  //     setSortDirection((prevDirection) =>
  //       prevDirection === "asc" ? "desc" : prevDirection === "desc" ? "default" : "asc"
  //     );
  //   } else {
  //     setSortedField(field);
  //     setSortDirection("asc");
  //   }
  // };

  // const sortedTableBodyContent = useMemo(() => {
  //   if (!sortedField || sortDirection === "default") {
  //     return body;
  //   }

  //   const sortedData = [...body];

  //   sortedData.sort((a, b) => {
  //     const valueA = a[sortedField];
  //     const valueB = b[sortedField];

  //     if (typeof valueA === "object" && sortedField === "code") {
  //       return sortDirection === "asc"
  //         ? valueA.title.localeCompare(valueB.title)
  //         : valueB.title.localeCompare(valueA.title);
  //     }
  //     if (typeof valueA === "string" && typeof valueB === "string") {
  //       return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  //     } else if (typeof valueA === "boolean" && typeof valueB === "boolean") {
  //       return sortDirection === "asc" ? Number(valueA) - Number(valueB) : Number(valueB) - Number(valueA);
  //     }

  //     return 0;
  //   });

  //   return sortedData;
  // }, [sortedField, sortDirection, body]) as TableBodyContentTypes[];

  return (
    <FlexRow>
      <FlexCol className="w-full">
        test
        {/* <TableList
          head={header}
          body={sortedTableBodyContent}
          sort={handleSort}
          sortDirection={sortDirection}
          sortedField={sortedField}
          tableName={tableName}
        />
        {count > limit && <Pagination numberOfPages={numberOfPages} page={page} onChange={onChangePage} />} */}
      </FlexCol>
    </FlexRow>
  );
}

export default Table;

// function TableList({
//   head,
//   body,
//   sort,
//   sortDirection,
//   sortedField,
//   tableName,
// }: {
//   head: Record<TableHeaderFields, TableColumn>;
//   body: TableBodyContentTypes[];
//   sort: (f: TableHeaderFields) => void;
//   sortedField: TableHeaderFields | null;
//   sortDirection: "asc" | "desc" | "default";
//   tableName: string;
// }) {
//   const tableFields = useMemo(() => {
//     return Object.keys(head) as TableHeaderFields[];
//   }, [head]);

//   return (
//     <FlexRow className="px-6 py-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-thumb-[#D1D5DB]">
//       <FlexCol className="divide-y min-w-[1252px] grow">
//         <FlexRow className="pb-5 gap-x-4">
//           {tableFields.map((fieldKey) => {
//             return (
//               <TableHeaderColumn
//                 key={fieldKey}
//                 tableHeaderContent={head[fieldKey]}
//                 sortDirection={sortedField === fieldKey ? sortDirection : "default"}
//                 onClick={() => sort(fieldKey)}
//               />
//             );
//           })}
//         </FlexRow>
//         {Array.isArray(body) && body.length > 0 ? (
//           body.map((item) => (
//             <FlexRow className="py-4 gap-x-4" key={item.id}>
//               {tableFields.map((fieldKey) => (
//                 <FlexCol key={fieldKey} className="break-words text-[#637381]" style={head[fieldKey].style}>
//                   {renderBodyCellValue(fieldKey, item, tableName)}
//                 </FlexCol>
//               ))}
//             </FlexRow>
//           ))
//         ) : (
//           <FlexRow>Список пуст</FlexRow>
//         )}
//       </FlexCol>
//     </FlexRow>
//   );
// }
// export function TableHeaderColumn({ tableHeaderContent, sortDirection, onClick }: TableHeaderColumnProps) {
//   return (
//     <FlexCol className="select-none" style={tableHeaderContent.style}>
//       <FlexRow className="items-center gap-x-2">
//         {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
//         <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
//         {tableHeaderContent.sort && (
//           <FlexCol className="w-auto cursor-pointer" onClick={onClick}>
//             <SortIcon sortDirection={sortDirection} />
//           </FlexCol>
//         )}
//       </FlexRow>
//     </FlexCol>
//   );
// }

// function renderBodyCellValue(fieldKey: TableHeaderFields, item: any, tableName: string): JSX.Element | JSX.Element[] {
//   if (fieldKey === "status") {
//     return <StatusListItem status={item[fieldKey]} />;
//   }
//   if (fieldKey === "responsibleForRevision") return <span>{item[fieldKey].name}</span>;
//   if (fieldKey === "approversList") return <ApprovalListItem items={item[fieldKey]} />;
//   if (fieldKey === "critical") return <CriticallyListItem item={item[fieldKey]} />;
//   if (fieldKey === "name") return <span className="text-darkblue">{item[fieldKey]}</span>;
//   return <span>{item[fieldKey]}</span>;
// }

// function getStatus(status: CodeStatus): JSX.Element {
//   switch (status) {
//     case "На доработку":
//       return <OnRevisionIcon />;
//     case "На пересмотр":
//       return <OnReviewIcon />;
//     case "На согласовании":
//       return <OnApprovalIcon />;
//     case "Отклонен":
//       return <RejectedIcon />;
//     case "Черновик":
//       return <DraftIcon />;
//     default:
//       return <DraftIcon />;
//   }
// }

// function StatusListItem({ status }: { status: CodeStatus }) {
//   return (
//     <div className="flex items-center">
//       {status ? (
//         <TooltipItem position="top-right" tooltipsText={status}>
//           {getStatus(status)}
//         </TooltipItem>
//       ) : (
//         <DraftIcon />
//       )}
//     </div>
//   );
// }

// const approvalItemStyle = cva("inline-block w-5 h-5 rounded-full", {
//   variants: {
//     status: {
//       pending: "ring-white ring-2",
//       fulfilled: "ring-[#22AD5C] ring-2",
//       reject: "ring-[#BA0C2F] ring-2",
//     },
//   },
//   defaultVariants: {
//     status: "pending",
//   },
// });

// export function ApprovalListItem({ items }: { items: ApproverList[] }) {
//   function getStatus(status: ApprovedStatus): "fulfilled" | "reject" | "pending" {
//     switch (status) {
//       case "Утвержден":
//         return "fulfilled";
//       case "Отклонен":
//         return "reject";
//       default:
//         return "pending";
//     }
//   }

//   return (
//     <div className="flex -space-x-1">
//       {items.map((item) => (
//         <TooltipItem position="top" tooltipsText={item.name} key={item.name}>
//           <img
//             key={item.name}
//             className={twMerge(approvalItemStyle({ status: getStatus(item.approved.title) }))}
//             src={item.avatar}
//             alt={item.name}
//           />
//         </TooltipItem>
//       ))}
//     </div>
//   );
// }

const criticalItemStyle = cva("block h-4 w-4 tablet:h-2 tablet:w-2 rounded-full", {
  variants: {
    active: {
      true: "bg-[#BA0C2F]",
      false: "bg-[#8899A8]",
    },
  },
  defaultVariants: {
    active: false,
  },
});

export function CriticallyListItem({ item, isShowText = true }: { item: boolean, isShowText?: boolean }) {
  return (
    <FlexRow className="items-center space-x-1">
      <FlexCol>
        <span className={twMerge(criticalItemStyle({ active: item }))}></span>
      </FlexCol>
      {
        isShowText && <FlexCol>{item ? "" : "Не "}Критичный</FlexCol>
      }
    </FlexRow>
  );
}
